module.exports = __webpack_public_path__ + "img/ticket_inactive_wide.4c477277.svg";